<template>
  <v-window v-model="tab">
    <v-window-item>
      <list
          ref="tab0"
          :open-tab="openTab"/>
    </v-window-item>
    <v-window-item>
      <detail
          ref="tab1"
          :open-tab="openTab"
          :item="item"/>
    </v-window-item>
    <v-window-item>
      <create-or-update
          ref="tab2"
          :open-tab="openTab"
          :item="item"/>
    </v-window-item>
  </v-window>
</template>

<script>
import Detail from "./Detail";
import CreateOrUpdate from "./CreateOrUpdate";
import List from "./List";

export default {
  name: "GroupMain",
  components: {CreateOrUpdate, Detail, List},
  data() {
    return {
      loading: true,
      item: null,
      tab: 0
    }
  },
  methods: {
    openTab(tab, data) {
      this.tab = tab
      this.item = data
      let t = this.$refs[`tab${tab}`]
      if (t) return t.onTab(this.item)
    }
  }
}
</script>

<style scoped>

</style>